import { render, staticRenderFns } from "./workgroupSearch.vue?vue&type=template&id=271b1efe&scoped=true"
import script from "./workgroupSearch.vue?vue&type=script&lang=js"
export * from "./workgroupSearch.vue?vue&type=script&lang=js"
import style0 from "./workgroupSearch.vue?vue&type=style&index=0&id=271b1efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b1efe",
  null
  
)

export default component.exports